import { connect } from 'react-redux';
import AccessorySection from './AccessorySection';
import {
  getAccessories,
  getCornerPostAccessories,
  getInputDataToSend,
  getCornerAccessories,
} from '../../../../store/form/selectors';

const mapStateToProps = (state) => ({
  accessories: getAccessories(state),
  cornerPostAccessories: getCornerPostAccessories(state),
  cornerAccessories: getCornerAccessories(state),
  inputData: getInputDataToSend(state),
});

export default connect(mapStateToProps)(AccessorySection);
